var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-resource-helper-components-3-resource-list",staticStyle:{"text-align":"left"}},[_c('ProductResourceHelperComponents4ProductResourceItem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }